/**
 * Asset Reservation actions
 */
export enum AssetReservationActionEnum {
	/**
	 * Set asset reservation status to cancelled
	 */
	CANCEL = 'cancel',
}
